import React from "react";
import "./productDemoPage.css";
import TextEditorPage from "../textEditorPage/TextEditorPage.jsx"
import { ProductDemoFooter } from "../../elements/ProductDemoFooter/index.jsx";

const ProductDemoPage = () => {
  return (
    <div className="product-demo-page">
      <TextEditorPage isProductDemo={true} />
      <ProductDemoFooter />
    </div>
  );
};

export default ProductDemoPage;
